import type {
  LandingPageHero,
  LandingPageBenefits,
  LandingPageApproach,
  LandingPageWhatYouGet,
  LandingPageKlartext,
  LandingPagePricingIntro,
  LandingPageClosing,
  LandingPageContent,
} from './types';
import { DEFAULT_APPROACH, DEFAULT_CLOSING, DEFAULT_CONTENT, DEFAULT_HERO, DEFAULT_PRICING_INTRO } from './default';

const TRADE_HERO: LandingPageHero = {
  headline: 'Du investierst bereits – willst aber gezielt mehr aus dem Markt rausholen?',
  subheadlineLines: [
    'Willst du Chancen nutzen, statt nur zu hoffen?',
    'Nicht hinterherrennen, wenn alle euphorisch sind.',
    'Nicht zu spät rausgehen, wenn die Bewegung schon vorbei ist.',
    'Sondern handeln, wenn der Chart die Chance zeigt.',
  ],
  descriptionLines: [
    'Ich zeige dir nicht, welche Aktie als nächstes läuft.',
    'Ich zeige dir, wann und warum ich Trades öffne – und wieder schließe.',
  ],
  ctaLabel: DEFAULT_HERO.ctaLabel,
};

const TRADE_BENEFITS: LandingPageBenefits = {
  headline: 'Du kennst das wahrscheinlich:',
  painPoints: [
    'Du steigst zu spät ein – die Bewegung ist schon gelaufen und der Trade frisst Nerven',
    'Du hältst zu lange – aus einem sauberen Gewinn wird Mittelmaß oder ein Verlust',
    'Du springst auf jeden Trend auf, den du in den News siehst – ohne Plan wann du wieder raus willst',
    'Du verwechselst Bewegung mit Chance – und triffst dadurch zu viele schlechte Trades',
  ],
  conclusion: '…und am Ende des Jahres steht weniger im Depot, als eigentlich drin wäre.',
  punchline: 'Die Börse ist nicht das Problem. Deine fehlende Struktur ist es.',
};

const TRADE_APPROACH: LandingPageApproach = {
  philosophyLines: DEFAULT_APPROACH.philosophyLines,
  finalLine: DEFAULT_APPROACH.finalLine,
  bridgeLine: DEFAULT_APPROACH.bridgeLine,
  bulletItems: [
    'Wann startet eine Bewegung wirklich – und wann täuscht sie nur?',
    'Wann ist der Einstieg sauber – und wann zu riskant?',
    'Wann nimmst du Gewinne mit – und wann lässt du laufen?',
  ],
};

const TRADE_WHAT_YOU_GET: LandingPageWhatYouGet = {
  headline: 'Was du hier bekommst:',
  subheadline: 'Keine Theorie – sondern gelebte Praxis',
  highlight: 'Meine konkreten Swing-Trades und langfristigen Einstiege – mit klarem Setup, definiertem Einstieg und Ausstieg. Regelmäßige Q&A Videos und der Kontext, warum ich handele – nicht nur was.',
};

const TRADE_KLARTEXT: LandingPageKlartext = {
  title: 'Klartext',
  notForYouHeader: 'Das hier ist nichts für dich, wenn',
  notForYou: 'du nur auf den nächsten Hot-Tipp wartest, keinen Plan umsetzen willst oder glaubst, dass Bauchgefühl auf Dauer reicht.',
  forYouHeader: 'Das hier ist für dich, wenn',
  forYouLines: [
    'du aktiv handeln willst – aber endlich strukturiert mit klaren Setups arbeiten möchtest.',
    'du Swing-Trades nutzen willst, aber wissen möchtest, wann der Moment wirklich passt.',
    'du aufgehört hast, Trends hinterherzulaufen – und verstehen willst, wie der Markt wirklich tickt.',
  ],
};

const TRADE_PRICING_INTRO: LandingPagePricingIntro = {
  mainHeadline: DEFAULT_PRICING_INTRO.mainHeadline,
  beforeHeader: 'Du hörst auf:',
  beforeItems: [
    'Trades aus dem Bauch zu öffnen, weil eine News spannend klingt',
    'Gewinne laufen zu lassen, bis sie wieder weg sind',
    'Auf Hoffnung zu setzen statt auf einen Plan',
  ],
  afterHeader: 'Und fängst an:',
  afterItems: [
    'Mit klaren Setups in Swing-Trades und Langzeit-Positionen einzusteigen',
    'Ein- und Ausstiege bewusst zu planen statt zu raten',
    'Dein Trading systematisch aufzubauen – Trade für Trade',
  ],
};

const TRADE_CLOSING: LandingPageClosing = {
  sloganLines: [
    { text: 'Einstieg nach', highlight: 'Chart!' },
    { text: 'Ausstieg nach', highlight: 'Plan!' },
  ],
  ctaLabel: DEFAULT_CLOSING.ctaLabel,
};

export const TRADE_CONTENT: LandingPageContent = {
  ...DEFAULT_CONTENT,
  hero: TRADE_HERO,
  benefits: TRADE_BENEFITS,
  approach: TRADE_APPROACH,
  whatYouGet: TRADE_WHAT_YOU_GET,
  klartext: TRADE_KLARTEXT,
  pricingIntro: TRADE_PRICING_INTRO,
  closing: TRADE_CLOSING,
};
